document.addEventListener('DOMContentLoaded', () => {
    if(document.getElementById('emailInput')){
        let emailInputCollection = document.getElementById('emailInput')

        checkEmail(emailInputCollection)

        emailInputCollection.addEventListener('input', (e) => {
            checkEmail(e.target)
        })
    }
    if(document.querySelector('input[name="agree"]')){
        let radioButtonCollection = document.querySelectorAll('input[name="agree"]')
        radioButtonCollection.forEach(radioButton => {
            radioButton.addEventListener('change', e => {
                if(e.target.checked){
                    document.querySelector('.button').classList.remove('button--in-active')
                }
            })
        })
    }

    if (document.getElementById('date')) {
        let contractDate = document.getElementById('date');
        console.log('date: ', contractDate)

        Inputmask({
            mask: "99.99.9999",
            showMaskOnHover: false,
        }).mask(contractDate);

    }



    if (document.querySelector('.js-input-number-new')) {
        const contractNumberInput = document.querySelector('.js-input-number-new');
        const mask = 'AAAAAAAA99 № 9999999999';

        if (contractNumberInput) {

            // Обработчик события ввода
            contractNumberInput.addEventListener('input', () => {
                const value = contractNumberInput.value.toUpperCase(); // Приведение к верхнему регистру
                let newValue = '';
                let valueIndex = 0;

                for (let i = 0; i < mask.length; i++) {
                    if (valueIndex >= value.length) {
                        break;
                    }

                    const maskChar = mask[i];
                    const inputChar = value[valueIndex];

                    if (maskChar === 'A') {
                        if (/[А-ЯЁ]/.test(inputChar)) {
                            newValue += inputChar;
                            valueIndex++;
                        } else {
                            valueIndex++;
                            i--;
                        }
                    } else if (maskChar === '9') {
                        if (/\d/.test(inputChar)) {
                            newValue += inputChar;
                            valueIndex++;
                        } else {
                            valueIndex++;
                            i--;
                        }
                    } else {
                        if (inputChar === maskChar) {
                            newValue += inputChar;
                            valueIndex++;
                        } else {
                            newValue += maskChar;
                        }
                    }
                }

                contractNumberInput.value = newValue;
            });

            // Дополнительная валидация при потере фокуса
            contractNumberInput.addEventListener('blur', () => {
                const regex = /^[А-ЯЁ]{8}\d{2} № \d{10}$/;
                if (!regex.test(contractNumberInput.value)) {
                    console.warn('Номер контракта введён неверно.');
                }
            });
        }

    }


    function checkEmail(input) {
        let regex = /^[a-z-._0-9]+@[a-z-._0-9]+\.[a-z0-9]{2,10}$/i;
        if(regex.test(input.value) === true){
            document.querySelector('.button').classList.remove('button--in-active')
        }
        else {
            document.querySelector('.button').classList.add('button--in-active')
        }
    }
});
